// import httpManager from '@/app/shared/utils/httpManager'
import httpManager from "../../utils/httpManager";

export async function fetchAllCountries() {
  const url = "/parameters/countries/";
  const response = await httpManager.get(url, { isPublic: true });
  return response.data;
}
